<style>
  /*:host {
    --bright-blue: oklch(51.01% 0.274 263.83);
    --electric-violet: oklch(53.18% 0.28 296.97);
    --french-violet: oklch(47.66% 0.246 305.88);
    --vivid-pink: oklch(69.02% 0.277 332.77);
    --hot-red: oklch(61.42% 0.238 15.34);
    --orange-red: oklch(63.32% 0.24 31.68);

    --gray-900: oklch(19.37% 0.006 300.98);
    --gray-700: oklch(36.98% 0.014 302.71);
    --gray-400: oklch(70.9% 0.015 304.04);

    --red-to-pink-to-purple-vertical-gradient: linear-gradient(
      180deg,
      var(--orange-red) 0%,
      var(--vivid-pink) 50%,
      var(--electric-violet) 100%
    );

    --red-to-pink-to-purple-horizontal-gradient: linear-gradient(
      90deg,
      var(--orange-red) 0%,
      var(--vivid-pink) 50%,
      var(--electric-violet) 100%
    );

    --pill-accent: var(--bright-blue);

    font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", 
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }*/

  p {
    margin: 0;
    color: var(--gray-700);
  }

  main {
    width: 100%;
    min-height: calc(100vh - 64px - 54px);
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: flex-start;
    /*padding: 1rem;*/
    box-sizing: inherit;
    position: relative;
  }

  .content {
    /*display: flex;
    flex-flow: column;*/
    /*justify-content: space-between;*/
    width: 100%;
    height: 100%;
    margin-top: 0;
    /*padding: 1rem;*/
    /*margin-bottom: 3rem;*/
  }

  .content h1 {
    margin-top: 1.75rem;
  }

  .content p {
    margin-top: 1.5rem;
  }

  .divider {
    width: 1px;
    background: var(--red-to-pink-to-purple-vertical-gradient);
    margin-inline: 0.5rem;
  }


  @media screen and (max-width: 650px) {
    .content {
      flex-direction: column;
      width: max-content;
    }

    .divider {
      height: 1px;
      width: 100%;
      background: var(--red-to-pink-to-purple-horizontal-gradient);
      margin-block: 1.5rem;
    }
  }

  app-forget-password {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
    height: 100%;
  }
  .login-component {
    width: 100%;
    height: 100%;
    padding: 2rem;
    background-color: var(--gray-900);
    border-radius: 1rem;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    gap: 1rem;
  }

</style>


<mat-drawer-container autosize>
  <mat-drawer #drawer  opened mode="side" *ngIf="authService.isAuthenticated">
    <app-sidebar-menu [expanded]="isSidebarExpanded"/>
  </mat-drawer>
  <mat-drawer-content >
    <app-header *ngIf="authService.isAuthenticated" (toggleSidebar)="toggleSidebar()"></app-header>
    <main class="main d-flex flex-column flex-grow-1 mt-0">  
      <div class="content mt-0 d-flex flex-column flex-grow-1">
        <router-outlet></router-outlet>
      </div>
    </main>
  </mat-drawer-content>

</mat-drawer-container>
<footer class="page-footer">
  <app-footer class="w-100"></app-footer>
</footer>

